import React from 'react'
// import Tabs from "../../elements/Tabs";
import Tabs from "../../elements/Tabs";
import Buy from "./BuySell/Buy";
import Sell from "./BuySell/Sell";

const PaymentInterface = () => {

  const tabs = [
    {
      _id: 1,
      name: "Buy",
      component: <Buy/>
    },
    {
      _id: 2,
      name: "Sell",
      component: <Sell/>
    }, 
  ]; 

  
  return (
    <>
      <div className="relative mt-10 h-full">
        <Tabs
          tabs={tabs}
          tabContainerClass={"!items-center "}
          tabNavClass={"justify-start lg:justify-center bg-[#F3F4F6]  !overflow-hidden !gap-0"}
          tabButtonClass={"!h-8  xl:!h-10  !rounded min-w-48  !bg-transparent  !text-shades-09 !text-lg"}
          tabButtonActiveClass={"!bg-primary !border border-primaryBorder !text-white"}
          tabContentClass={"!py-5 md:!py-7"}
        />
      </div>
    </>
  )
}

export default PaymentInterface;